import { render, staticRenderFns } from "./addConfiguration.vue?vue&type=template&id=023c24fa&scoped=true"
import script from "./addConfiguration.vue?vue&type=script&lang=js"
export * from "./addConfiguration.vue?vue&type=script&lang=js"
import style0 from "./addConfiguration.vue?vue&type=style&index=0&id=023c24fa&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023c24fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('023c24fa')) {
      api.createRecord('023c24fa', component.options)
    } else {
      api.reload('023c24fa', component.options)
    }
    module.hot.accept("./addConfiguration.vue?vue&type=template&id=023c24fa&scoped=true", function () {
      api.rerender('023c24fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/lottery/activity/components/addConfiguration.vue"
export default component.exports